
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class CommonTitle extends Vue {
  @Prop() zh: string;
  @Prop() en: string;
  @Prop() morePath: string;
  @Prop({ type: Boolean, default: true })
  showBorder: boolean;

  toMore() {
    const isExternal = /^(https?:|mailto:|tel:)/.test(this.morePath);
    if (isExternal) {
      window.open(this.morePath, '_blank');
    } else {
      const resolved = this.$router.resolve({ path: this.morePath });
      window.open(resolved.href, '_blank')
    }
  }
}
